var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 213,
    viewBox: "0 0 257 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.931 1.01258C129.713 -1.40333 153.42 16.6331 174.402 33.839C197.382 52.6831 225.551 73.0645 224.644 101.641C223.747 129.938 195.043 149.339 170.223 165.533C150.201 178.598 126.247 179.688 101.931 181.709C73.7308 184.052 40.6388 196.439 20.3262 177.988C-0.0273995 159.5 9.53787 127.883 13.7845 101.641C17.2259 80.3747 27.2149 62.007 41.7871 45.3714C58.6089 26.1677 75.5065 3.31051 101.931 1.01258Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.9268,
    y: 34.7578,
    width: 102.607,
    height: 125.927,
    rx: 12,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6655,
    y: 49.5605,
    width: 31.8477,
    height: 8.02682,
    rx: 4.01341,
    fill: "#010101"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6655,
    y: 71.6338,
    width: 69.1294,
    height: 8.02682,
    rx: 4.01341,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6655,
    y: 93.708,
    width: 69.1294,
    height: 8.02682,
    rx: 4.01341,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6655,
    y: 115.782,
    width: 69.1294,
    height: 8.02682,
    rx: 4.01341,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67.6655,
    y: 137.855,
    width: 69.1294,
    height: 8.02682,
    rx: 4.01341,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 168.863,
    y: 18.9678,
    width: 87.3544,
    height: 49.0691,
    rx: 8,
    fill: "#F2F2F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 179.863,
    y: 33.9678,
    width: 8.76601,
    height: 8.76601,
    rx: 4.38301,
    fill: "#D5D5D5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 195.629,
    y: 33.9678,
    width: 31.2465,
    height: 8.76601,
    rx: 4.38301,
    fill: "#D5D5D5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 214.54,
    y: 120.407,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.799 75.7103C124.902 76.6499 118.263 78.964 112.277 82.5155C106.29 86.067 101.077 90.7837 96.9461 96.3864C92.8918 101.886 89.9604 108.13 88.3193 114.763C86.6783 121.395 86.3596 128.286 87.3816 135.041C88.4037 141.797 90.7463 148.285 94.2758 154.135C97.8053 159.986 102.453 165.083 107.952 169.137C113.452 173.192 119.696 176.123 126.328 177.764C132.961 179.405 139.852 179.724 146.607 178.702C153.363 177.68 159.851 175.337 165.701 171.808C171.551 168.278 176.649 163.631 180.703 158.131C184.758 152.632 187.689 146.388 189.33 139.755C190.971 133.123 191.29 126.232 190.268 119.476C189.246 112.721 186.903 106.233 183.374 100.382C179.844 94.5322 175.197 89.4345 169.697 85.3803C158.803 77.3505 145.209 73.8818 131.799 75.7103ZM132.851 83.4322C144.253 81.877 155.813 84.8267 165.076 91.6552C169.752 95.1021 173.703 99.4362 176.704 104.41C179.705 109.384 181.697 114.9 182.566 120.644C183.435 126.388 183.164 132.247 181.769 137.886C180.373 143.525 177.881 148.834 174.434 153.509C170.987 158.185 166.653 162.137 161.679 165.138C156.705 168.139 151.188 170.13 145.445 170.999C139.701 171.868 133.842 171.597 128.203 170.202C122.564 168.807 117.255 166.314 112.579 162.867C107.903 159.42 103.952 155.086 100.951 150.112C97.9502 145.138 95.9584 139.622 95.0895 133.878C94.2205 128.134 94.4915 122.276 95.8868 116.637C97.2822 110.998 99.7746 105.689 103.222 101.013C106.733 96.2494 111.165 92.2391 116.254 89.2192C121.344 86.1994 126.988 84.2316 132.851 83.4322Z",
    fill: "#D6D8E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.078 138.026C157.87 139.818 157.87 142.723 156.078 144.514C154.287 146.306 151.381 146.306 149.59 144.514L121.571 116.496C119.779 114.704 119.779 111.799 121.571 110.007C123.363 108.215 126.268 108.215 128.059 110.007L156.078 138.026Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.059 144.514C126.267 146.306 123.362 146.306 121.57 144.514C119.779 142.722 119.779 139.817 121.57 138.025L149.589 110.006C151.381 108.215 154.286 108.215 156.078 110.006C157.87 111.798 157.87 114.703 156.078 116.495L128.059 144.514Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.802 168.553L179.951 154.371L216.615 190.95C220.531 194.857 220.538 201.199 216.631 205.115C212.724 209.031 206.382 209.039 202.466 205.132L165.802 168.553Z",
    fill: "#D6D8E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8287 36.1447C49.9351 30.3206 60.525 21.4993 65.2825 15.2314L67.665 17.0398C62.4762 23.8759 51.121 33.2273 40.5387 39.1824C40.8164 41.8597 40.268 44.8948 38.5639 48.1923C34.5381 55.9822 24.0103 65.3596 2.05159 75.6466L0.782715 72.938C22.5893 62.7223 32.3507 53.6999 35.9067 46.8191C37.0838 44.5413 37.5739 42.5143 37.6133 40.7505C32.9166 43.1375 28.3585 44.7974 24.624 45.0443C22.4734 45.1864 20.431 44.8712 18.7962 43.7837C17.1376 42.6803 16.1121 40.9257 15.726 38.637C15.2842 36.9915 15.7012 35.1295 16.5464 33.5065C17.4252 31.8188 18.8576 30.201 20.7168 29.0407C24.5396 26.6547 29.9856 26.3064 35.8314 30.7127L35.8452 30.7231L35.8588 30.7338C37.5037 32.0345 38.9739 33.8582 39.8287 36.1447ZM37.172 37.611C36.5614 35.7007 35.3794 34.1717 34.0169 33.0906C29.0877 29.382 24.9899 29.8995 22.3004 31.5781C20.9021 32.4507 19.8355 33.6661 19.1993 34.888C18.5453 36.1437 18.4306 37.2276 18.6248 37.8977L18.6504 37.9859L18.665 38.0765C18.9369 39.7673 19.6086 40.7317 20.4528 41.2933C21.3415 41.8844 22.6442 42.1776 24.4267 42.0597C27.7896 41.8375 32.268 40.1936 37.172 37.611Z",
    fill: "#8387BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsNotFound);
export default __webpack_public_path__ + "static/media/resultsNotFound.487c195a482abc60bfe1eea221320c53.svg";
export { ForwardRef as ReactComponent };